<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">アーティスト選択</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area>
          登録アーティストからメインアーティストを選択してください。
          <span>
            5組以上が参加している場合は「 Various Artists 」を選択してください。
          </span>
        </release-step-area>
        <div class="add-artist-btn-area">
          <div class="add-artist-btn-area__column--left add-artist-btn-area__column--half">
            <div class="add-artist-btn-area__title">新規アーティスト登録</div>
            <div class="add-artist-btn-area__wrap">
              <router-link
                :to="{ name : 'artist-create-from-release' }"
                class="add-artist-btn-area__btn">
                <div class="add-artist-btn-area__icon">
                  <svg
                    class="icon-add_artist svg-icon"
                    viewBox="0 0 55.5 57.5">
                    <path
                      class="color2"
                      d="M29.7,49.9c-0.2,0-0.5,0-0.7,0h-0.6c-0.5,0-1-0.4-1-0.9l0-0.6v-0.2C28,
                      48.9,28.8,49.5,29.7,49.9z M25.2,23.9c2,0,3.8,0.7,5.3,1.8c0.7-0.3,1.4-0.6,
                      2.2-0.8c-1.9-1.9-4.6-3-7.5-3h-0.8c-0.3,0-0.5,0.1-0.7,0.3l-5.3,5l-5.3-5
                      c-0.2-0.2-0.4-0.3-0.7-0.3h-0.8c-5.9,0-10.7,4.7-10.7,10.4v10.9c0,3.7,3.2,
                      6.7,7,6.7h0.5c0.6,0,1-0.4,1-1V36.7c0-0.5-0.5-1-1-1s-1,0.4-1,
                      1V48c-2.5-0.2-4.5-2.3-4.5-4.7V32.4c0-4.7,3.9-8.4,8.7-8.4H12l5.7,
                      5.4c0.4,0.4,1,0.4,1.4,0l5.7-5.4H25.2z" />
                    <path
                      class="color1"
                      d="M18.3,21C13,21,8.7,15.9,8.7,9.5c0-5.8,3.7-9.6,9.5-9.6s9.5,3.8,9.5,
                      9.6C27.8,15.9,23.5,21,18.3,21z M18.3,2c-4.7,0-7.6,2.8-7.6,7.6c0,5.2,
                      3.4,9.5,7.6,9.5c4.2,0,7.6-4.2,7.6-9.5C25.8,4.8,23,2,18.3,2z M36,
                      25c-7.2,0-13,5.8-13,13s5.8,13,13,13c7.2,0,13-5.8,13-13S43.2,25,36,
                      25z M36,49c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S42.1,49,36,
                      49z M41,39h-4v4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-4h-4c-0.6,0-1-0.4-1-1s0.4-1,
                      1-1h4v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4h4c0.6,0,1,0.4,1,1S41.6,39,41,39z" />
                  </svg>
                </div>
                追加する
                <span class="c-btn__icon-arrow c-btn__icon-arrow--def">
                </span>
              </router-link>
            </div>
          </div>
          <div
            class="add-artist-btn-area__column--right add-artist-btn-area__column--half">
            <div class="add-artist-btn-area__title">複数アーティスト登録</div>
            <div class="add-artist-btn-area__wrap">
              <a
                href="#"
                class="add-artist-btn-area__btn"
                @click.prevent="selectVariousArtist">
                <div class="add-artist-btn-area__icon">
                  <svg
                    class="icon-add_va svg-icon"
                    viewBox="0 0 73.5 57.5">
                    <path
                      class="color1"
                      d="M34.9,50h-0.4c-0.4,0-0.8-0.3-0.8-0.7l0-0.4v-8.1c0-0.4,0.4-0.8,
                      0.8-0.8c0.5,0,0.8,0.4,0.8,0.8l0,7.6c1.6-0.2,2.8-1.5,
                      2.8-3.1v-7.4c0-3.1-2.6-5.6-5.7-5.6h-0.2l-3.8,3.6c-0.3,0.3-0.8,0.3-1.1,
                      0l-3.8-3.6h-0.2c-3.2,0-5.7,2.5-5.7,5.6v7.4c0,1.6,1.2,2.9,2.8,
                      3.1v-7.6c0-0.4,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v8.4c0,0.4-0.4,0.8-0.8,
                      0.8h-0.4c-2.7,0-4.9-2.1-4.9-4.7v-7.4c0-4,3.3-7.3,7.4-7.3h0.6c0.2,0,0.4,0.1,
                      0.6,0.2l3.5,3.3l3.5-3.3c0.2-0.1,0.4-0.2,0.6-0.2h0.6c4.1,0,7.4,3.3,
                      7.4,7.3v7.4C39.7,47.9,37.5,50,34.9,50z M27.7,30.5c-3.7,0-6.8-3.5-6.8-7.9c0-4,
                      2.7-6.6,6.8-6.6s6.8,2.6,6.8,6.6C34.5,27,31.4,30.5,27.7,30.5z M27.7,17.6c-3.2,
                      0-5.1,1.9-5.1,5c0,3.5,2.3,6.3,5.1,6.3c2.8,0,5.1-2.8,5.1-6.3C32.9,19.5,30.9,
                      17.6,27.7,17.6z M54,51c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13S61.2,51,
                      54,51z M54,27c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S60.1,27,
                      54,27z M59,39h-4v4c0,0.6-0.4,1-1,1s-1-0.4-1-1v-4h-4c-0.6,0-1-0.4-1-1s0.4-1,
                      1-1h4v-4c0-0.6,0.4-1,1-1s1,0.4,1,1v4h4c0.6,0,1,0.4,1,1S59.6,39,59,39z" />
                    <path
                      class="color2"
                      d="M11.7,0.9c-4,0-6.6,2.6-6.6,6.6c0,4.4,3,7.9,6.6,7.9c3.7,0,
                      6.6-3.6,6.6-7.9C18.3,3.5,15.7,0.9,11.7,0.9zM11.7,13.8c-2.8,
                      0-5-2.8-5-6.3c0-3.1,1.9-5,5-5s5,1.9,5,5C16.7,11,14.5,13.8,11.7,13.8z" />
                    <path
                      class="color2"
                      d="M20,16.9c0.1,0.2,0,0.5-0.1,0.7l-0.2,0.3c-0.9,1.4-1.3,3-1.3,4.8v4.3c0,
                      0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8v-4.3c0-1.9,0.4-3.7,
                      1.3-5.2c-0.6-0.2-1.3-0.4-1.9-0.4H16l-3.7,3.6c-0.3,0.3-0.8,0.3-1.1,
                      0l-3.7-3.6H7.2c-3.1,0-5.6,2.5-5.6,5.7v7.4c0,1.6,1.2,2.9,2.7,
                      3.1v-7.6c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8v8.5c0,0.4-0.4,0.8-0.8,
                      0.8H4.8C2.1,35,0,32.9,0,30.2v-7.4c0-4,3.2-7.3,7.2-7.3h0.5c0.2,0,0.4,0.1,0.6,
                      0.2l3.4,3.3l3.4-3.3c0.1-0.1,0.3-0.2,0.6-0.2h0.5c1,0,2.1,0.2,3,0.7l0.4,
                      0.2C19.8,16.5,20,16.7,20,16.9z" />
                    <path
                      class="color2"
                      d="M36.2,12.8l-1.7,2.5c-0.2,0.2-0.4,0.4-0.7,0.4c-0.1,0-0.3,
                      0-0.4-0.1c-0.4-0.2-0.5-0.7-0.2-1.1l1.7-2.5c0.8-1.3,1.3-2.9,1.2-4.7c0-4.4,
                      2.8-7.2,7.2-7.2c4.3,0,7.2,2.8,7.2,7.2c0,1.9,0.4,3.5,1.2,4.8l1.7,2.5c0.2,0.4,
                      0.1,0.9-0.2,1.1c-0.4,0.2-0.9,
                      0.1-1.1-0.2l-1.7-2.5c-1-1.6-1.5-3.5-1.5-5.7c0-3.5-2.1-5.6-5.6-5.6c-3.5,
                      0-5.6,2.1-5.6,5.6C37.7,9.4,37.2,11.3,36.2,12.8z" />
                    <path
                      class="color2"
                      d="M42.7,20.8L39,17.1h-0.2c-0.6,0-1.3,0.1-1.9,0.4c0.8,1.5,1.3,3.3,1.3,
                      5.2v4.3c0,0.4-0.4,0.8-0.8,
                      0.8c-0.4,0-0.8-0.4-0.8-0.8v-4.3c0-1.8-0.4-3.4-1.3-4.8L35,
                      17.5c-0.1-0.2-0.2-0.4-0.1-0.7c0.1-0.2,0.2-0.4,
                      0.4-0.5l0.4-0.2c1-0.5,2-0.7,3-0.7h0.5c0.2,0,0.4,0.1,0.6,
                      0.2l3.4,3.3l3.4-3.3c0.1-0.1,0.3-0.2,0.6-0.2h0.5c4,0,7.2,3.3,7.2,7.3v0.8c-0.3,
                      0-0.7-0.1-1-0.1c-0.2,0-0.4,0-0.6,0v-0.8c0-3.1-2.5-5.7-5.6-5.7h-0.2l-3.7,
                      3.6C43.5,21.1,43,21.1,42.7,20.8z" />
                  </svg>
                </div>
                Various Artists
                <span class="c-btn__icon-arrow c-btn__icon-arrow--def">
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="c-heading c-heading--with-search">
          <div
            class="c-heading__text-box">
            <p
              v-if="isBtoC"
              class="c-heading__title">
              マイアーティスト（アーティスト、著作者、役割）
            </p>
            <p
              v-else
              class="c-heading__title">
              マイアーティスト（アーティスト、著作者）
            </p>
            <span>
              4組まで選択可能です。数字の順番にアーティスト名が表記されます。
            </span>
          </div>
          <div class="add-artist-search-wrap">
            <div class="add-artist-search-text">アーティスト検索</div>
            <input
              v-model="keyword"
              class="add-artist-search"
              type="search">
          </div>
        </div>
        <div
          v-if="isBtoC"
          class="vocaloid-notice">
          VOCALOID、その他音声合成ソフトを使った配信については、以下ページをご確認ください。
          <div>
            <a
              href="https://narasu.jp/lp/vocalo/"
              class="c-text-link u-bold"
              target="_blank">
              &gt;&gt;VOCALOID、その他音声合成ソフトの利用について
            </a>
          </div>
        </div>
        <div>
          <p
            v-if="errors.main_artists"
            class="error-text">
            {{ errors.main_artists[0] }}
          </p>
        </div>
        <div
          class="artist-list">
          <a
            class="artist-list__item"
            href="#"
            @click.prevent="showVocaloidListPopUp">
            <div
              class="artist-list__pic"
              :style="`background-image: url(/images/vocaloid_image.png)`">
            </div>
            <div
              class="artist-list__name"
              style="padding: 0 20px">
              <span class="artist-list__name_text">
                VOCALOID/<br />その他音声合成ソフト
              </span>
            </div>
          </a>
          <a
            v-for="item in selectedVocaloids"
            :key="`voc${item.id}`"
            class="artist-list__item"
            href="#"
            @click.prevent="selectVocaloid(item)">
            <div
              class="artist-list__pic"
              :style="`background-image: url(/images/${item.image_path})`">
            </div>
            <div class="artist-list__name">
              <span class="artist-list__name_text">
                {{ item.name }}
              </span>
              <span
                class="c-btn__icon-check"
                :class="{ 'c-btn__icon-check--on': isActive(item.id) }">
              </span>
            </div>
            <div
              v-if="isActive(item.id)"
              class="artist-list__num">
              {{ selectedNumber(item.id) }}
            </div>
          </a>
          <template
            v-if="serachStatus === 0">
            <a
              v-for="item in pagination.data"
              :key="item.id"
              class="artist-list__item"
              href="#"
              @click.prevent="selectArtist(item.id)">
              <div
                class="artist-list__pic"
                :style="`background-image: url(/images/${item.image_path})`">
              </div>
              <div class="artist-list__name">
                <span class="artist-list__name_text">
                  {{ item.name }}
                </span>
                <span
                  class="c-btn__icon-check"
                  :class="{ 'c-btn__icon-check--on': isActive(item.id) }">
                </span>
              </div>
              <div
                v-if="isActive(item.id)"
                class="artist-list__num">
                {{ selectedNumber(item.id) }}
              </div>
            </a>
          </template>
          <template v-else-if="serachStatus === 1">
            <p class="artist-not-exist">
              このキーワードのアーティストは登録されていません。
            </p>
          </template>
          <template v-else>
            <p class="artist-not-exist">
              アーティストが登録されていません。
            </p>
          </template>
        </div>
        <div class="pager">
          <div
            v-if="pagination.data"
            class="pager">
            <pagination
              :pagination="pagination"
              @on-pagination-clicked="onPaginationClicked">
            </pagination>
          </div>
        </div>
        <div class="c-btn-wrap">
          <a
            class="c-btn"
            :class="{ 'c-btn--off': selectedArtists.length === 0 }"
            href="#"
            @click.prevent="onNextClicked(1)">
            確定する
            <span class="c-btn__icon-arrow"></span>
          </a>
        </div>
      </div>
      <basic-modal
        v-if="popUpDialogShown"
        :is-active="popUpDialogShown"
        :remaining-number="4-selectedArtists.length"
        :already-selected-vocaloid="selectedVocaloids"
        :comparable-vocaloid="[]"
        :is-adding-for-featuring="false"
        :is-selected-user-artist="isSelectedUserArtist"
        width="700px"
        title="ボーカロイド"
        @modal-cancel="closeModel"
        @modalConfirm="modalConfirm($event)"
        @item-to-be-deleted="itemToBeDeleted($event)">
      </basic-modal>
    </div>
  </div>
</template>

<script>
import ReleaseStepArea from '../StepArea'
import Pagination from '../../../../components/Pagination'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import BasicModal from '../../../../components/Modal'

let timer = null
export default {
  name: 'ReleaseStep1',
  components: {
    BasicModal,
    ReleaseTypeLabel,
    HeaderBar,
    ReleaseStepArea,
    Pagination,
  },
  data() {
    return {
      selectedArtists: [],
      currentSelectedVocaloid: [],
      selectedVocaloids: [],
      pagination: {},
      type: '',
      variousArtist: {},
      vocaloid: {},
      keyword: '',
      serachStatus: 0,
      artistType: 0,
      popUpDialogShown: false,
      isSelectedUserArtist: false,
      errors: [],
    }
  },
  watch: {
    keyword() {
      this.onSearchKeywordChanged()
    },
    selectedArtists() {
      this.isSelectedUserArtist = this.selectedArtists.length - this.selectedVocaloids.length > 0
    },
  },
  mounted() {
    // ストレージ情報が空であれば不正アクセス
    window.sessionStorage.removeItem('submitReleaseForm')
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.type = release.type
    // アーティスト情報を初期化
    this.fetchItems()
    this.fetchVariousArtist()
    this.fetchVocaloids()
    // ストレージから選択済みアーティスト情報を復元
    this.selectedArtists = release.artists || []
    if (release.vocaloid?.length > 0) {
      release.vocaloid.forEach(vocaloid1 => {
        this.selectedVocaloids.push(vocaloid1)
        this.currentSelectedVocaloid.push(vocaloid1)
      })
    }
    this.artistType = release.artistType ?? 0
  },
  methods: {
    async fetchItems(page) {
      const params = {
        keyword: this.keyword,
      }
      let artistType = '1'
      if (this.$store.state.auth.company.is_pndr_managed_non_admin) {
        artistType = '1,4'
      }
      const response = await window.axios.get(`/api/client/artists?type=${artistType}&page=${page}&count=50`, { params })
      this.pagination = response.data
      if (Object.keys(this.pagination.data).length > 0) {
        this.serachStatus = 0
      } else if (Object.keys(this.pagination.data).length <= 1 && this.keyword) {
        this.serachStatus = 1
      } else {
        this.serachStatus = 2
      }
    },
    async fetchVariousArtist() {
      const response = await window.axios.get('/api/client/artists?type=2')
      this.variousArtist = window._.first(response.data.data)
    },
    async fetchVocaloids() {
      const response = await window.axios.get('/api/client/vocaloids')
      this.vocaloid = window._.first(response.data.data)
    },
    selectVocaloid(vocaloid) {
      const vocaloidIndex = this.currentSelectedVocaloid.indexOf(vocaloid)
      const artistIndex = this.selectedArtists.indexOf(vocaloid.id)
      if (vocaloidIndex !== -1 && artistIndex !== -1) {
        this.selectedVocaloids.splice(this.selectedVocaloids.indexOf(vocaloid), 1)
      } else {
        this.currentSelectedVocaloid.push(vocaloid)
      }
      this.selectArtist(vocaloid.id)
    },
    selectArtist(artistId) {
      // ヴァリアスアーティストが選択状態で戻ってきたときにアーティストを選択した場合は一旦リセット
      if (this.artistType === 2) {
        this.selectedArtists = []
        this.artistType = 1
      }
      const max = this.type === 'album' ? 4 : 4
      const index = this.selectedArtists.indexOf(artistId)
      if (index !== -1) {
        this.selectedArtists.splice(index, 1)
      } else if (this.selectedArtists.length < max) {
        this.selectedArtists.push(artistId)
      }
      // ユーザーアーティスト選択が0になった場合にユーザーアーティスト必須のボーカロイドを選択していた場合に非選択
      if (this.selectedArtists.length - this.selectedVocaloids.length === 0
        && this.selectedVocaloids.length > 0) {
        this.selectedVocaloids
          .filter(artist => artist.require_user_artist === 1)
          .forEach((vocaloid) => {
            this.selectedVocaloids.splice(
              this.selectedVocaloids.findIndex(v => v.id === vocaloid.id), 1,
            )
            this.selectedArtists.splice(
              this.selectedArtists.findIndex(id => id === vocaloid.id), 1,
            )
          })
      }
    },
    selectVariousArtist() {
      this.selectedArtists = [this.variousArtist.id]
      this.onNextClicked(2)
    },
    isActive(artistId) {
      return this.selectedArtists.indexOf(artistId) !== -1
    },
    selectedNumber(artistId) {
      return this.selectedArtists.indexOf(artistId) + 1
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
    },
    async onNextClicked(artistType = 1) {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      window.sessionStorage.removeItem('hasLyricsError')
      window.sessionStorage.removeItem('lyricsCompletePercentage')
      release.artists = this.selectedArtists
      release.artistType = artistType

      const formData = {
        type: this.type,
        artist_id: [],
      }
      if (release.product && release.product.id) {
        formData.id = release.product.id
      }
      this.selectedArtists.forEach(artist => {
        formData.artist_id.push(artist)
      })
      try {
        const { data } = await window.axios.post('/api/client/products/', formData)
        release.product.id = data.id
        release.product.is_draft = data.is_draft

        window.sessionStorage.setItem('album', JSON.stringify(release))
        window.scrollTo(0, 0)
        this.$router.push({ name: `${this.$route.meta.sideMenuId}-step2` })
      } catch ({ response }) {
        const { errors } = response.data
        this.errors = errors
        window.scrollTo(0, 0)
      }
    },
    onSearchKeywordChanged() {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => { this.fetchItems(0) }, 800)
    },
    showVocaloidListPopUp() {
      this.popUpDialogShown = true
    },
    closeModel() {
      this.popUpDialogShown = false
    },
    modalConfirm(event) {
      event.forEach(e => {
        if (this.selectedVocaloids.filter(vocaloid => vocaloid.id === e.id).length === 0) {
          this.selectedVocaloids.push(e)
          this.currentSelectedVocaloid.push(e)
          this.selectedArtists.push(e.id)
        }
      })
    },
    itemToBeDeleted(event) {
      event.forEach(element => {
        this.selectedVocaloids.forEach(element1 => {
          if (element1.id === element.id) {
            const index = this.selectedVocaloids.indexOf(element1)
            const artistIndex = this.selectedArtists.indexOf(element1.id)
            this.selectedArtists.splice(artistIndex, 1)
            this.selectedVocaloids.splice(index, 1)
            // this.currentSelectedVocaloid.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>

<style scoped>
p.error-text{
  display: inline;
}

.artist-not-exist {
  margin-top: 50px;
}
.vocaloid-notice {
  margin: 8px auto 25px 0;
  display: block;
  font-size: 1.4rem;
}
</style>
